/*
* 类型转换
* 用途：数据类型转换处理
* 用法：vue.$conversion
* 方法：
*     ArrayToString
*     StringToArray
* */
import typejudge from './typejudge.js';
class conversion {
  ArrayToString (array) { // 将数组转换成字符串
    if (!typejudge.isArray(array)) { // 非数组返回空字符串
      console.warn('this data is not an array, in function ArrayToString in conversion. data = ' + array);
      return false;
    }
    return '[' + array.join(',') + ']';
  };
  StringToArray (string) { // 字符串转换成数组
    if (!typeof string === 'string') { // 非字符串返回空数组
      console.warn('this data is not an string, in function StringToArray in conversion. data = ' + string);
      return false;
    }
    var shot = string.slice(1, string.length - 1);
    return shot.split(',');
  }
}
// export storage类的对象
export default new conversion();



// WEBPACK FOOTER //
// ./src/utils/conversion.js